module.exports = __webpack_public_path__ + "static/price_bg-fb692b2f0595b9e357336e13a54be439.png";